import Crud from '@/stores/crudBase';
import api from '@/apis/convert/convertDataCompareAPI.js';
var crud = new Crud('convertDataCompare', api);

const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Lấy dữ liệu đối chiếu sau khi convert
   * @param {*} context
   * @param {*} payload
   * @returns
   * DDTHANG 28.11.2022
   */
  async getDataCompareConvert(context, payload) {
    return await api.getDataCompareConvert(payload || {});
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  mutations,
  actions,
  getters,
};
